// export const mainBaseUrl = 'http://localhost:5173/';
// export const apiBaseUrl = 'http://localhost/my_projects/LoanAdmin/backendapis/';

// export const mainBaseUrl = "https://ai-business-manger.vercel.app/";
export const mainBaseUrl = "https://admin.borocredit.in/";
export const apiBaseUrl = 'https://api.borocredit.in/';

